export default "__VITE_ASSET__B8WECy61__"